// cleanup_convert_to_typescript_file_GENERICS

import { createUseStyles } from '@glu/theming';

const styles = ({ palette: { grey }, spacing: { unit } }) => ({
  addWidgetContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& [class^="selectFieldWrapper"]': {
      borderRadius: 30,
      '& button[data-qa="addWidget-select-field"]': {
        height: 28
      },
      '& button[class*="disabled"]': {
        '& [class^="icon-caret-down"]': {
          fill: '#B8CFE7'
        }
      },
      '& div[class^="iconWrapper"]': {
        top: unit
      }
    },
    '& [class^="wrapper"]': {
      width: 200,
      '& [class^="placeholder"]': {
        fontSize: `${unit * 1.5}px`,
        '&[class*="disabled"]': {
          color: '#B8CFE7'
        }
      },
      '& div[class^="root"]': {
        borderBottomRightRadius: 5,
        borderBottomLeftRadius: 5,
        '& [class^="linkTitle"]': {
          color: grey.A700
        }
      },
      '& button[class^="input"]': {
        borderRadius: 'inherit'
      }
    }
  },
  helpText: {
    fontSize: 11,
    marginTop: 8,
    color: '#a1c2e1'
  }
});

export default createUseStyles(styles);
